import React from "react";
import { Card, CardBody } from "reactstrap";
import { useLocation } from "react-router-dom";

const PinSuccessDetails: React.FC = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

const fromMemberId = decodeURIComponent(query.get("FromMemberId") || "").replace(/<\/?br\s*\/?>/gi, "").replace(/"/g, "");
const toMemberId = decodeURIComponent(query.get("ToMemberId") || "").replace(/<\/?br\s*\/?>/gi, "").replace(/"/g, "");

const quantity     = (query.get("PINCount") || "").replace(/"/g, "");
const date         = (query.get("PinTransferDate") || "").replace(/"/g, "");


  return (
    <Card className="shadow-sm border-0 rounded-3">
      <div className="bg-light p-3 rounded-top">
        <h5 className="mb-0">Pin Success Details</h5>
      </div>
      <CardBody className="text-center">
        {/* Success Icon */}
        <div className="mb-3">
          <div
            style={{
              width: "70px",
              height: "70px",
              border: "3px solid #3db0f0",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
            }}
          >
            <span style={{ color: "#3db0f0", fontSize: "30px" }}>✔</span>
          </div>
        </div>

        {/* Main Message */}
        <h5 className="fw-bold">Process Completed Successfully!</h5>
        <p className="text-muted mb-4">Thank you</p>

        {/* Details */}
        <div className="text-start mx-auto" style={{ maxWidth: "500px" }}>
          <p>
       <strong>From Member Id:</strong>{fromMemberId}
{/* <span dangerouslySetInnerHTML={{ __html: fromMemberId }} /> */}
          </p>
          <p>
            <strong>Transfer Pin Quantity:</strong> {quantity}
          </p>
          <p>
            <strong>To Member Id:</strong> {toMemberId}
          </p>
          <p>
            <strong>Pin Transfer Date:</strong> {date}
          </p>
        </div>
      </CardBody>
    </Card>
  );
};

export default PinSuccessDetails;
